import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const SellerProduct = () => {
  const [ProductUser, setProductUser] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const navigate = useNavigate();
  const sellerId = localStorage.getItem("seller_id");


  // PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ProductUser.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(ProductUser.length / itemsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // ===================== FETCH ALL DATA =====================
  useEffect(() => {
  const fetchAll = async () => {
    try {
      const sellerId = localStorage.getItem("seller_id");

      if (!sellerId) {
        toast.error("Seller not logged in");
        navigate("/login");
        return;
      }

      // Categories
      const catRes = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
      );
      if (catRes.data.status === true) {
        setCategories(catRes.data.row);
      }

      // Subcategories
      const subRes = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
      );
      if (subRes.data.status === true) {
        setSubcategories(subRes.data.row);
      }

      // 🔥 Products by Seller ID
      const formData = new FormData();
      formData.append("seller_id", sellerId);

      const prodRes = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (prodRes.data.status === true) {
        setProductUser(prodRes.data.data || []);
      } else {
        setProductUser([]);
        toast.error("No products found for this seller");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error fetching seller products");
    }
  };

  fetchAll();
}, []);


  // Convert Category ID → Name
  const getCategoryName = (id) => {
    const category = categories.find((c) => String(c.category_id) === String(id));
    return category ? category.category_name : "-";
  };

  // Convert Subcategory ID → Name
  const getSubCategoryName = (id) => {
    const sub = subcategories.find((s) => String(s.subcategory_id) === String(id));
    return sub ? sub.subcategory_name : "-";
  };

  // ===================== DELETE PRODUCT =====================
  const deleteUser = async (userId) => {
    const formData = new FormData();
    formData.append("product_id", userId);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_create_product",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === "true" || response.data.status === true) {
        setProductUser((prev) =>
          prev.filter((user) => user.product_id !== userId)
        );
        toast.error(response.data.message || "Product deleted successfully!");
      } else {
        toast.error(response.data.message || "Delete failed.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete product.");
    }
  };

  // ===================== STATUS HANDLING FIX =====================
 const getStatusUI = (statusValue) => {
  let text = "Out of Stock";
  let css = "bg-danger-subtle text-danger";

  if (statusValue === "In Stock") {
    text = "In Stock";
    css = "bg-success-subtle text-success";
  }
  if (statusValue === "Few Left") {
    text = "Few Left";
    css = "bg-warning-subtle text-warning";
  }

  return { text, css };
};

const getPaidPromoUI = (paidApproval) => {
  if (paidApproval === "yes") {
    return {
      text: "Paid Promotion",
      css: "bg-primary-subtle text-primary",
    };
  }
  return null;
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* PAGE TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Product List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Product</Link>
                </li>
                <li className="breadcrumb-item active">Product List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* TABLE SECTION */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-1">
                <h4 className="card-title flex-grow-1">All Product List</h4>
                {/* <Link to="/product-add" className="btn btn-sm btn-primary">
                  Add Product
                </Link> */}
              </div>

              <div>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: 20 }}>
                          <div className="form-check ms-1 fs-16">
                            <input type="checkbox" className="form-check-input" />
                          </div>
                        </th>
                        <th>Product Name & Size</th>
                        <th>Product Category</th>
                        <th>Sub Category</th>
                        <th>Current Price</th>
                        <th>Old Price</th>
                        <th>Stock</th>
                        <th>Rating</th>
                        <th>Vendor</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((user) => {
                          const statusData = getStatusUI(user.status);

                          return (
                            <tr key={user.product_id}>
                              <td>
                                <div className="form-check ms-1 fs-16">
                                  <input type="checkbox" className="form-check-input" />
                                </div>
                              </td>

                              {/* PRODUCT IMAGE + NAME */}
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                    <img
                                      src={
                                        user.multi_image && user.multi_image.length > 0
                                          ? `https://cyberathon.com/multivendor/${user.multi_image[0]}`
                                          : "https://via.placeholder.com/80x80?text=No+Image"
                                      }
                                      alt={user.product_name}
                                      className="avatar-md"
                                    />
                                  </div>

                                  <div>
                                    <span className="text-dark fw-medium fs-15">
                                      {user.product_name || "N/A"}
                                    </span>
                                    <p className="text-muted mb-0 mt-1 fs-13">
                                      Size: {user.available_size || "N/A"}
                                    </p>
                                  </div>
                                </div>
                              </td>

                              {/* CATEGORY */}
                              <td>{getCategoryName(user.category_id)}</td>

                              {/* SUBCATEGORY */}
                              <td>{getSubCategoryName(user.subcategory_id)}</td>

                              <td>{user.current_price}</td>
                              <td>{user.old_price || "-"}</td>

                              {/* STOCK */}
                              <td>
                                <span className="text-dark fw-medium">
                                  {user.stock} Items
                                </span>
                              </td>

                              <td>{user.rating || "-"}</td>
                              <td>{user.assign_vendor || "-"}</td>

                              {/* STATUS FIXED */}
                              <td>
  <div className="d-flex flex-column gap-1">
    {/* Stock Status */}
    <span className={`badge ${statusData.css} py-1 px-2`}>
      {statusData.text}
    </span>

    {/* Paid Promotion Status */}
    {getPaidPromoUI(user.paid_approval) && (
      <span
        className={`badge ${
          getPaidPromoUI(user.paid_approval).css
        } py-1 px-2`}
      >
        {getPaidPromoUI(user.paid_approval).text}
      </span>
    )}
  </div>
</td>


                              {/* ACTION BUTTONS */}
                              <td>
                                <div className="d-flex gap-2">
                                  <Link
                                    to={`/sellerproduct/${user.product_id}`}
                                    className="btn btn-light btn-sm"
                                  >
                                    <i className="fa-solid fa-eye fs-18"></i>
                                  </Link>

                                  <Link
                                    to={`/sellerproduct-edit/${user.product_id}`}
                                    className="btn btn-soft-primary btn-sm"
                                  >
                                    <i className="fa-solid fa-pencil fs-18"></i>
                                  </Link>

                                  <span
                                    onClick={() => deleteUser(user.product_id)}
                                    className="btn btn-soft-danger btn-sm"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fa-solid fa-trash fs-18"></i>
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center py-3">
                            No Products Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* PAGINATION */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <span className="page-link" onClick={() => paginate(currentPage - 1)}>
                        Previous
                      </span>
                    </li>

                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <span className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </span>
                      </li>
                    ))}

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <span className="page-link" onClick={() => paginate(currentPage + 1)}>
                        Next
                      </span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 text-center">
                    © Venton. Crafted by{" "}
                    <iconify-icon
                      icon="iconamoon:heart-duotone"
                      className="fs-18 align-middle text-danger"
                    />{" "}
                    <Link to="#" className="fw-bold footer-text" target="_blank">
                      Techzaa
                    </Link>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
};


export const SellerProductCreate = () => {
  const navigate = useNavigate();

  const initialFormState = {
    // Basic product fields
    product_name: "",
    current_price: "",
    old_price: "",
    prod_stock: "",
    rating: "",
    description: "",
    product_details: "",
    prod_vendor_assign: "",
    prod_size: "",
    status: "",
    discount_id: "",
    discount: "",
    product_status:"",


    // Category selectors
    main_category: "",
    sub_category: "",
    size_id: [], // Changed to array for multiple sizes

    // Electronics fields
    company_name: "",
    model_name: "",
    ram: "",
    rom: "",
    processor: "",
    camera: "",
    battery: "",
    operating_system: "",
    available_colors: [],

    // Fashion fields
    fashion_brand_name: "",
    material: "",
    fit_type: "",
    occasion: "",
    available_size: [],
    available_color: [],
    care_instructions: "",

    // images
    prod_image: null,
    prod_multi_images: [],
  };

  const [ProductUser, setProductUser] = useState(initialFormState);
  const [previewImage, setPreviewImage] = useState(null);
  const [multiPreview, setMultiPreview] = useState([]);
  const [CategoryUser, setCategoryUser] = useState([]);
  const [SubCategoryUser, setSubCategoryUser] = useState([]);
  const [Sizeuser, setSizeUser] = useState([]);
  const [ColorUser, setColorUser] = useState([]);
  const [DiscountUser, setDiscountUser] = useState([]);
  const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
  const [isDiscountDropdownOpen, setIsDiscountDropdownOpen] = useState(false);

  // Generic input handler
  const handleInput = (e) => {
    const { name, value } = e.target;
    setProductUser((prev) => ({ ...prev, [name]: value }));
  };

  // Handle multi-select arrays
  const handleMultiSelect = (e, stateKey) => {
    const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
    setProductUser((prev) => ({ ...prev, [stateKey]: selected }));
  };

 // Replace your handleSizeCheckbox function with this updated version:

const handleSizeCheckbox = (sizeId) => {
  setProductUser((prev) => {
    const currentSizes = prev.size_id || [];
    const sizeIdStr = String(sizeId);
    
    let updatedSizes;
    if (currentSizes.includes(sizeIdStr)) {
      // Remove if already selected
      updatedSizes = currentSizes.filter((id) => id !== sizeIdStr);
    } else {
      // Add if not selected
      updatedSizes = [...currentSizes, sizeIdStr];
    }
    
    // Update BOTH size_id and available_size with the same values
    return {
      ...prev,
      size_id: updatedSizes,
      available_size: updatedSizes  // This ensures available_size is also updated
    };
  });
};


  const handleColorCheckbox = (colorId) => {
    setProductUser((prev) => {
      const currentColors = prev.available_color || [];
      const colorIdStr = String(colorId);
      
      if (currentColors.includes(colorIdStr)) {
        return {
          ...prev,
          available_color: currentColors.filter((id) => id !== colorIdStr)
        };
      } else {
        return {
          ...prev,
          available_color: [...currentColors, colorIdStr]
        };
      }
    });
  };

  // Handle single image
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   setProductUser((prev) => ({ ...prev, prod_image: file }));
  //   if (file) {
  //     setPreviewImage(URL.createObjectURL(file));
  //   } else {
  //     setPreviewImage(null);
  //   }
  // };

  // Handle multiple images
  const handleMultiImageChange = (e) => {
    const files = Array.from(e.target.files || []);
    setProductUser((prev) => ({ ...prev, prod_multi_images: files }));
    const previews = files.map((f) => URL.createObjectURL(f));
    setMultiPreview(previews);
  };

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        setCategoryUser(res.data?.row || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
        );
        setSizeUser(response.data?.row || []);
      } catch (err) {
        console.error("Error fetching Sizes:", err);
      }
    };
    fetchSize();
  }, []);

  useEffect(() => {
    const fetchColour = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
        );
        setColorUser(response.data?.colors || []);
      } catch (err) {
        console.error("Error fetching Colours:", err);
      }
    };
    fetchColour();
  }, []);

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/discount_list"
        );
        setDiscountUser(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching Discounts:", err);
      }
    };
    fetchDiscount();
  }, []);

  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!ProductUser.main_category) {
        setSubCategoryUser([]);
        return;
      }
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        const all = res.data?.row || [];
        const filtered = all.filter(
          (sub) => String(sub.category_id) === String(ProductUser.main_category)
        );
        setSubCategoryUser(filtered);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchSubcategories();
  }, [ProductUser.main_category]);

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();


      formData.append("product_name", (ProductUser.product_name || "").trim());
      formData.append("current_price", (ProductUser.current_price || "").trim());
      formData.append("old_price", (ProductUser.old_price || "").trim());
      formData.append("stock", (ProductUser.prod_stock || "").trim());
      formData.append("rating", (ProductUser.rating || "").trim());
      formData.append("description", (ProductUser.description || "").trim());
      formData.append("product_details", (ProductUser.product_details || "").trim());
      formData.append("assign_vendor", (ProductUser.prod_vendor_assign || "").trim());
      formData.append("size", (ProductUser.prod_size || "").trim());
      let mappedStatus = "Out of Stock"; // default

if (ProductUser.status === "Instock") mappedStatus = "In Stock";
if (ProductUser.status === "Outofstock") mappedStatus = "Out of Stock";
if (ProductUser.status === "fewleft") mappedStatus = "Few Left";

formData.append("status", mappedStatus);

formData.append("product_status", ProductUser.product_status || "");





      formData.append("category_id", ProductUser.main_category || "");
      formData.append("subcategory_id", ProductUser.sub_category || "");
      
      formData.append(
        "size_id",
        Array.isArray(ProductUser.size_id)
          ? ProductUser.size_id.join(",")
          : ProductUser.size_id || ""
      );

      formData.append("company_name", ProductUser.company_name || "");
      formData.append("model_name", ProductUser.model_name || "");
      formData.append("ram", ProductUser.ram || "");
      formData.append("rom", ProductUser.rom || "");
      formData.append("processor", ProductUser.processor || "");
      formData.append("camera", ProductUser.camera || "");
      formData.append("battery", ProductUser.battery || "");
      formData.append("operating_system", ProductUser.operating_system || "");
      // formData.append(
      //   "available_colors",
      //   Array.isArray(ProductUser.available_colors)
      //     ? ProductUser.available_colors.join(",")
      //     : ProductUser.available_colors || ""
      // );

      // Fashion fields
      formData.append("fashion_brand_name", ProductUser.fashion_brand_name || "");
      formData.append("material", ProductUser.material || "");
      formData.append("fit_type", ProductUser.fit_type || "");
      formData.append("occasion", ProductUser.occasion || "");
      formData.append(
        "available_size",
        Array.isArray(ProductUser.available_size)
          ? ProductUser.available_size.join(",")
          : ProductUser.available_size || ""
      );
      formData.append(
        "available_color",
        Array.isArray(ProductUser.available_color)
          ? ProductUser.available_color.join(",")
          : ProductUser.available_color || ""
      );
      formData.append("care_instructions", ProductUser.care_instructions || "");
      formData.append("discount_id", ProductUser.discount_id || "");
formData.append("discount", ProductUser.discount || "");

      
      if (Array.isArray(ProductUser.prod_multi_images) && ProductUser.prod_multi_images.length) {
        ProductUser.prod_multi_images.forEach((file) => {
          formData.append("multi_image[]", file);
        });
      }

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_create_product",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const data = response.data;
      const success =
        data?.status === true || data?.success === "1" || data?.status === "true";

      if (success) {
        toast.success(data?.message || "Product added successfully!");
        setProductUser(initialFormState);
        setPreviewImage(null);
        setMultiPreview([]);
        navigate("/sellerproduct");
      } else {
        toast.error(data?.message || "Failed to add product");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Product</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">Product</li>
                <li className="breadcrumb-item active">Create Product</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <form onSubmit={submitForm}>
              {/* Image Upload */}
              <div className="card mb-3">
                <div className="card-header">
                  <h4 className="card-title">Add Product Photo</h4>
                </div>
                <div className="card-body">
                  <label className="form-label text-dark">Product Multiple Images</label>
                  <input
                    type="file"
                    multiple
                    className="form-control"
                    accept="image/*"
                    onChange={handleMultiImageChange}
                  />
                  <div className="d-flex gap-2 mt-2">
                    {multiPreview.map((p, i) => (
                      <img
                        key={i}
                        src={p}
                        alt={`multi-${i}`}
                        style={{ width: "80px", height: "auto", borderRadius: "6px" }}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Product Information</h4>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        name="product_name"
                        value={ProductUser.product_name}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter product name"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Current Price</label>
                      <input
                        type="number"
                        name="current_price"
                        value={ProductUser.current_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Old Price</label>
                      <input
                        type="number"
                        name="old_price"
                        value={ProductUser.old_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    {/* CATEGORY SELECTION */}
                    <div className="col-lg-6">
                      <label className="form-label">Main Category</label>
                      <select
                        className="form-control"
                        name="main_category"
                        value={ProductUser.main_category}
                        onChange={(e) =>
                          setProductUser((prev) => ({
                            ...prev,
                            main_category: e.target.value,
                            sub_category: "",
                          }))
                        }
                      >
                        <option value="">-- Select Main Category --</option>
                        {CategoryUser.map((item) => (
                          <option key={item.category_id} value={String(item.category_id)}>
                            {item.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* SUBCATEGORY */}
                    {ProductUser.main_category && (
                      <div className="col-lg-6">
                        <label className="form-label">Subcategory</label>
                        <select
                          className="form-control"
                          name="sub_category"
                          value={ProductUser.sub_category}
                          onChange={handleInput}
                        >
                          <option value="">-- Select Subcategory --</option>
                          {SubCategoryUser.map((item) => (
                            <option key={item.subcategory_id} value={String(item.subcategory_id)}>
                              {item.subcategory_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* SIZE SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Sizes</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}
                        >
                          <span>
                            {ProductUser.size_id && ProductUser.size_id.length > 0
                              ? `${ProductUser.size_id.length} size(s) selected`
                              : "Select sizes"}
                          </span>
                          <span>{isSizeDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isSizeDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {Sizeuser.length > 0 ? (
                                Sizeuser.map((size) => (
                                  <div key={size.size_id} className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`size-${size.size_id}`}
                                      checked={(ProductUser.size_id || []).includes(String(size.size_id))}
                                      onChange={() => handleSizeCheckbox(size.size_id)}
                                    />
                                    <label className="form-check-label" htmlFor={`size-${size.size_id}`}>
                                      {size.size_label || size.size}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No sizes available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* COLOR SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Colors</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                        >
                          <span>
                            {ProductUser.available_color && ProductUser.available_color.length > 0
                              ? `${ProductUser.available_color.length} color(s) selected`
                              : "Select colors"}
                          </span>
                          <span>{isColorDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isColorDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {ColorUser.length > 0 ? (
                                ColorUser.map((color) => (
                                  <div key={color.color_id} className="form-check mb-2 d-flex align-items-center">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`color-${color.color_id}`}
                                      checked={(ProductUser.available_color || []).includes(String(color.color_id))}
                                      onChange={() => handleColorCheckbox(color.color_id)}
                                    />
                                    <label className="form-check-label d-flex align-items-center" htmlFor={`color-${color.color_id}`}>
                                      <span
                                        className="d-inline-block me-2 ms-2"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          backgroundColor: color.code,
                                          border: "1px solid #ddd",
                                          borderRadius: "3px"
                                        }}
                                      ></span>
                                      {color.color_name}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No colors available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* ELECTRONICS BLOCK */}
                    {String(ProductUser.main_category) === "1" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Electronics Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            name="company_name"
                            value={ProductUser.company_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Apple"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Model Name</label>
                          <input
                            type="text"
                            name="model_name"
                            value={ProductUser.model_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. iPhone 16"
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label">Specifications</label>
                          <div className="row g-3">
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="ram"
                                value={ProductUser.ram}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="RAM (e.g. 8GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="rom"
                                value={ProductUser.rom}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="ROM (e.g. 128GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="processor"
                                value={ProductUser.processor}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Processor"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="camera"
                                value={ProductUser.camera}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Camera"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="battery"
                                value={ProductUser.battery}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Battery (mAh)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="operating_system"
                                value={ProductUser.operating_system}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Operating System"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* FASHION BLOCK */}
                    {String(ProductUser.main_category) === "2" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Fashion Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Brand Name</label>
                          <input
                            type="text"
                            name="fashion_brand_name"
                            value={ProductUser.fashion_brand_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="Enter brand name (e.g. Levi's)"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Material</label>
                          <input
                            type="text"
                            name="material"
                            value={ProductUser.material}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Cotton"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Fit Type</label>
                          <input
                            type="text"
                            name="fit_type"
                            value={ProductUser.fit_type}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Regular Fit"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Occasion</label>
                          <input
                            type="text"
                            name="occasion"
                            value={ProductUser.occasion}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Casual"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Care Instructions</label>
                          <input
                            type="text"
                            name="care_instructions"
                            value={ProductUser.care_instructions}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Machine wash cold"
                          />
                        </div>
                      </>
                    )}

                    {/* Common remaining fields */}
                    <div className="col-lg-6">
                      <label className="form-label">Stock</label>
                      <input
                        type="text"
                        name="prod_stock"
                        value={ProductUser.prod_stock}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter stock quantity"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Rating</label>
                      <input
                        type="text"
                        name="rating"
                        value={ProductUser.rating}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter rating (e.g. 4.5)"
                      />
                    </div>

                    <div className="col-lg-6">
  <label className="form-label">Apply Discount</label>
  <div className="position-relative">

    {/* Selected discount display */}
    <div
      className="form-control d-flex justify-content-between align-items-center"
      style={{ cursor: "pointer" }}
      onClick={() => setIsDiscountDropdownOpen(!isDiscountDropdownOpen)}
    >
      <span>
        {ProductUser.discount_id
          ? DiscountUser.find(d => String(d.disc_id) === String(ProductUser.discount_id))?.disc_name
          : "Select discount"}
      </span>
      <span>{isDiscountDropdownOpen ? "▲" : "▼"}</span>
    </div>

    {isDiscountDropdownOpen && (
      <div
        className="border rounded bg-white position-absolute w-100 mt-1"
        style={{
          maxHeight: "250px",
          overflowY: "auto",
          zIndex: 1000,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
        }}
      >
        <div className="p-2">

          {/* No Discount Option */}
          <div
            className="p-2 hover-bg-light"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setProductUser(prev => ({
                ...prev,
                discount_id: "",
                discount: ""
              }));
              setIsDiscountDropdownOpen(false);
            }}
          >
            <small className="text-muted">No Discount</small>
          </div>

          {/* Discount List */}
          {DiscountUser.length > 0 ? (
            DiscountUser.filter(disc => disc.status === "1").map((item) => (
              <div
                key={item.disc_id}
                className="p-2 border-bottom hover-bg-light"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setProductUser(prev => ({
                    ...prev,
                    discount_id: item.disc_id,       // save discount ID
                    discount: item.disc_amount       // save discount AMOUNT
                  }));
                  setIsDiscountDropdownOpen(false);
                }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="fw-semibold">{item.disc_name}</div>
                    <small className="text-muted">
                      {item.disc_start_date} to {item.disc_end_date}
                    </small>
                  </div>
                  <span className="badge bg-success">₹{item.disc_amount} OFF</span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted mb-0 p-2">No active discounts available</p>
          )}
        </div>
      </div>
    )}
  </div>
</div>


                    <div className="col-lg-6">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        name="description"
                        value={ProductUser.description}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Short product description"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Product Details</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Additional details"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Weight</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter weight"
                      />
                    </div>


                    <div className="col-lg-6">
                      <label className="form-label">Dimension</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="42*44"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Assign Vendor</label>
                      <select
                        className="form-control"
                        name="prod_vendor_assign"
                        value={ProductUser.prod_vendor_assign}
                        onChange={handleInput}
                      >
                        <option value="">Select Vendor</option>
                        <option value="H&M">H&M</option>
                        <option value="Nike">Nike</option>
                        <option value="Zara">Zara</option>
                      </select>
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Product Status</label>
                      <select
                        className="form-control"
                        name="product_status"
                        value={ProductUser.product_status}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Product Status --</option>
                        <option value="Top Deals">Top Deals</option>
                        <option value="Fashion Top Deals">Fashion Top Deals</option>
                        <option value="Shop Your Favorites">Shop Your Favorites</option>
                        <option value="Special Offers">Special Offers</option>
                        <option value="Grand Global Brand">Grand Global Brand</option>
                        <option value="Shop By Category">Shop By Category</option>
                        <option value="Top Pick of the sale">Top Pick of the sale</option>
                        <option value="Crazy Deals">Crazy Deals</option>
                        <option value="Products for you">Products for you</option>
                        <option value="Groceries">Groceries</option>
                      </select>
                    </div>


                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={ProductUser.status}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Instock">In stock</option>
                        <option value="Outofstock">Out of stock</option>
                        <option value="fewleft">Few left</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-outline-secondary w-100">
                      Create Product
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/sellerproduct" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid text-center py-3">
          © Venton. Crafted by{" "}
          <span className="text-danger">❤️</span> <strong>Techzaa</strong>
        </div>
      </footer>
    </div>
  );
};



export const SellerProductEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const initialFormState = {
    product_name: "",
    current_price: "",
    old_price: "",
    prod_stock: "",
    rating: "",
    description: "",
    product_details: "",
    prod_vendor_assign: "",
    prod_size: "",
    status: "",
    product_status:"",
    paid_promo: "",

    main_category: "",
    sub_category: "",
    size_id: [],
    company_name: "",
    model_name: "",
    ram: "",
    rom: "",
    processor: "",
    camera: "",
    battery: "",
    operating_system: "",
    available_colors: [],
    fashion_brand_name: "",
    material: "",
    fit_type: "",
    occasion: "",
    available_size: [],
    available_color: [],
    care_instructions: "",
    prod_image: null,
    prod_multi_images: [],
    existing_multi_images: []
  };

  const [ProductUser, setProductUser] = useState(initialFormState);
  const [previewImage, setPreviewImage] = useState(null);
  const [multiPreview, setMultiPreview] = useState([]);
  const [CategoryUser, setCategoryUser] = useState([]);
  const [SubCategoryUser, setSubCategoryUser] = useState([]);
  const [Sizeuser, setSizeUser] = useState([]);
  const [ColorUser, setColorUser] = useState([]);
  const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch Product Data by ID
  useEffect(() => {
    const fetchProductData = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("product_id", id);

        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
          formData
        );

        if (response.data?.status && response.data?.data) {
          const product = response.data.data;
          
          setProductUser({
            product_name: product.product_name || "",
            current_price: product.current_price || "",
            old_price: product.old_price || "",
            prod_stock: product.stock || "",
            rating: product.rating || "",
            description: product.description || "",
            product_details: product.product_details || "",
            prod_vendor_assign: product.assign_vendor || "",
            prod_size: product.size || "",
            status: product.status || "",
            product_status: product.product_status || "",
            paid_promo: product.paid_promo || "",

            main_category: product.category_id || "",
            sub_category: product.subcategory_id || "",
            size_id: product.available_size ? product.available_size.split(',').filter(Boolean) : [],
            company_name: product.company_name || "",
            model_name: product.model_name || "",
            ram: product.ram || "",
            rom: product.rom || "",
            processor: product.processor || "",
            camera: product.camera || "",
            battery: product.battery || "",
            operating_system: product.operating_system || "",
            available_colors: product.available_colors ? product.available_colors.split(',').filter(Boolean) : [],
            fashion_brand_name: product.fashion_brand_name || "",
            material: product.material || "",
            fit_type: product.fit_type || "",
            occasion: product.occasion || "",
            available_size: product.available_size ? product.available_size.split(',').filter(Boolean) : [],
            available_color: product.available_color ? product.available_color.split(',').filter(Boolean) : [],
            care_instructions: product.care_instructions || "",
            prod_image: null,
            prod_multi_images: [],
            existing_multi_images: product.multi_image || []
          });

          // Set existing multi images preview
          if (product.multi_image && Array.isArray(product.multi_image)) {
            const existingPreviews = product.multi_image.map(
              img => `https://cyberathon.com/multivendor/${img}`
            );
            setMultiPreview(existingPreviews);
          }
        } else {
          toast.error("Failed to load product details");
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
        toast.error("Failed to load product details");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProductData();
    }
  }, [id]);

  // Fetch Categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        setCategoryUser(res.data?.row || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  // Fetch Sizes
  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
        );
        setSizeUser(response.data?.row || []);
      } catch (err) {
        console.error("Error fetching Sizes:", err);
      }
    };
    fetchSize();
  }, []);

  // Fetch Colors
  useEffect(() => {
    const fetchColour = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
        );
        setColorUser(response.data?.colors || []);
      } catch (err) {
        console.error("Error fetching Colours:", err);
      }
    };
    fetchColour();
  }, []);

  // Fetch Subcategories based on category
  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!ProductUser.main_category) {
        setSubCategoryUser([]);
        return;
      }
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        const all = res.data?.row || [];
        const filtered = all.filter(
          (sub) => String(sub.category_id) === String(ProductUser.main_category)
        );
        setSubCategoryUser(filtered);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchSubcategories();
  }, [ProductUser.main_category]);

  // Generic input handler
  const handleInput = (e) => {
    const { name, value } = e.target;
    setProductUser((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Size Checkbox
  const handleSizeCheckbox = (sizeId) => {
    setProductUser((prev) => {
      const currentSizes = prev.size_id || [];
      const sizeIdStr = String(sizeId);
      
      let updatedSizes;
      if (currentSizes.includes(sizeIdStr)) {
        updatedSizes = currentSizes.filter((id) => id !== sizeIdStr);
      } else {
        updatedSizes = [...currentSizes, sizeIdStr];
      }
      
      return {
        ...prev,
        size_id: updatedSizes,
        available_size: updatedSizes
      };
    });
  };

  // Handle Color Checkbox
  const handleColorCheckbox = (colorId) => {
    setProductUser((prev) => {
      const currentColors = prev.available_color || [];
      const colorIdStr = String(colorId);
      
      if (currentColors.includes(colorIdStr)) {
        return {
          ...prev,
          available_color: currentColors.filter((id) => id !== colorIdStr)
        };
      } else {
        return {
          ...prev,
          available_color: [...currentColors, colorIdStr]
        };
      }
    });
  };

  // Handle multiple images
  const handleMultiImageChange = (e) => {
    const files = Array.from(e.target.files || []);
    setProductUser((prev) => ({ ...prev, prod_multi_images: files }));
    const previews = files.map((f) => URL.createObjectURL(f));
    setMultiPreview(previews);
  };

  // Submit Form
  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      // Add product_id for update
      formData.append("product_id", id);

      // Basic fields
      formData.append("product_name", (ProductUser.product_name || "").trim());
      formData.append("current_price", (ProductUser.current_price || "").trim());
      formData.append("old_price", (ProductUser.old_price || "").trim());
      formData.append("stock", (ProductUser.prod_stock || "").trim());
      formData.append("rating", (ProductUser.rating || "").trim());
      formData.append("description", (ProductUser.description || "").trim());
      formData.append("product_details", (ProductUser.product_details || "").trim());
      formData.append("assign_vendor", (ProductUser.prod_vendor_assign || "").trim());
      formData.append("size", (ProductUser.prod_size || "").trim());
      let mappedStatus = "Out of Stock";  // default

if (ProductUser.status === "In Stock") mappedStatus = "In Stock";
if (ProductUser.status === "Out of Stock") mappedStatus = "Out of Stock";
if (ProductUser.status === "Few Left") mappedStatus = "Few Left";

formData.append("status", mappedStatus);

formData.append("product_status", ProductUser.product_status || "");
formData.append("discount_id", ProductUser.discount_id || "");



      // Category fields
      formData.append("category_id", ProductUser.main_category || "");
      formData.append("subcategory_id", ProductUser.sub_category || "");
      
      formData.append(
        "size_id",
        Array.isArray(ProductUser.size_id)
          ? ProductUser.size_id.join(",")
          : ProductUser.size_id || ""
      );

      // Electronics fields
      formData.append("company_name", ProductUser.company_name || "");
      formData.append("model_name", ProductUser.model_name || "");
      formData.append("ram", ProductUser.ram || "");
      formData.append("rom", ProductUser.rom || "");
      formData.append("processor", ProductUser.processor || "");
      formData.append("camera", ProductUser.camera || "");
      formData.append("battery", ProductUser.battery || "");
      formData.append("operating_system", ProductUser.operating_system || "");
      formData.append(
        "available_colors",
        Array.isArray(ProductUser.available_colors)
          ? ProductUser.available_colors.join(",")
          : ProductUser.available_colors || ""
      );

      // Fashion fields
      formData.append("fashion_brand_name", ProductUser.fashion_brand_name || "");
      formData.append("material", ProductUser.material || "");
      formData.append("fit_type", ProductUser.fit_type || "");
      formData.append("occasion", ProductUser.occasion || "");
      formData.append(
        "available_size",
        Array.isArray(ProductUser.available_size)
          ? ProductUser.available_size.join(",")
          : ProductUser.available_size || ""
      );
      formData.append(
        "available_color",
        Array.isArray(ProductUser.available_color)
          ? ProductUser.available_color.join(",")
          : ProductUser.available_color || ""
      );
      formData.append("care_instructions", ProductUser.care_instructions || "");

      // Images
      if (ProductUser.prod_image) {
        formData.append("prod_image", ProductUser.prod_image);
      }
      if (Array.isArray(ProductUser.prod_multi_images) && ProductUser.prod_multi_images.length) {
        ProductUser.prod_multi_images.forEach((file) => {
          formData.append("multi_image[]", file);
        });
      }

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_create_product",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const data = response.data;
      const success =
        data?.status === true || data?.success === "1" || data?.status === "true";

      if (success) {
        toast.success(data?.message || "Product updated successfully!");
        navigate("/sellerproduct");
      } else {
        toast.error(data?.message || "Failed to update product");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong while updating!");
    }
  };

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Edit Product</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">Product</li>
                <li className="breadcrumb-item active">Edit Product</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <form onSubmit={submitForm}>
              {/* Image Upload */}
              <div className="card mb-3">
                <div className="card-header">
                  <h4 className="card-title">Product Photos</h4>
                </div>
                <div className="card-body">
                  <label className="form-label text-dark">Product Multiple Images</label>
                  <input
                    type="file"
                    multiple
                    className="form-control"
                    accept="image/*"
                    onChange={handleMultiImageChange}
                  />
                  <small className="text-muted">Upload new images to replace existing ones</small>
                  <div className="d-flex gap-2 mt-2 flex-wrap">
                    {multiPreview.map((p, i) => (
                      <img
                        key={i}
                        src={p}
                        alt={`multi-${i}`}
                        style={{ width: "80px", height: "80px", borderRadius: "6px", objectFit: "cover" }}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Product Information</h4>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        name="product_name"
                        value={ProductUser.product_name}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter product name"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Current Price</label>
                      <input
                        type="number"
                        name="current_price"
                        value={ProductUser.current_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Old Price</label>
                      <input
                        type="number"
                        name="old_price"
                        value={ProductUser.old_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    {/* CATEGORY SELECTION */}
                    <div className="col-lg-6">
                      <label className="form-label">Main Category</label>
                      <select
                        className="form-control"
                        name="main_category"
                        value={ProductUser.main_category}
                        onChange={(e) =>
                          setProductUser((prev) => ({
                            ...prev,
                            main_category: e.target.value,
                            sub_category: "",
                          }))
                        }
                      >
                        <option value="">-- Select Main Category --</option>
                        {CategoryUser.map((item) => (
                          <option key={item.category_id} value={String(item.category_id)}>
                            {item.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* SUBCATEGORY */}
                    {ProductUser.main_category && (
                      <div className="col-lg-6">
                        <label className="form-label">Subcategory</label>
                        <select
                          className="form-control"
                          name="sub_category"
                          value={ProductUser.sub_category}
                          onChange={handleInput}
                        >
                          <option value="">-- Select Subcategory --</option>
                          {SubCategoryUser.map((item) => (
                            <option key={item.subcategory_id} value={String(item.subcategory_id)}>
                              {item.subcategory_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* SIZE SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Sizes</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}
                        >
                          <span>
                            {ProductUser.size_id && ProductUser.size_id.length > 0
                              ? `${ProductUser.size_id.length} size(s) selected`
                              : "Select sizes"}
                          </span>
                          <span>{isSizeDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isSizeDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {Sizeuser.length > 0 ? (
                                Sizeuser.map((size) => (
                                  <div key={size.size_id} className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`size-${size.size_id}`}
                                      checked={(ProductUser.size_id || []).includes(String(size.size_id))}
                                      onChange={() => handleSizeCheckbox(size.size_id)}
                                    />
                                    <label className="form-check-label" htmlFor={`size-${size.size_id}`}>
                                      {size.size_label || size.size}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No sizes available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* COLOR SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Colors</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                        >
                          <span>
                            {ProductUser.available_color && ProductUser.available_color.length > 0
                              ? `${ProductUser.available_color.length} color(s) selected`
                              : "Select colors"}
                          </span>
                          <span>{isColorDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isColorDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {ColorUser.length > 0 ? (
                                ColorUser.map((color) => (
                                  <div key={color.color_id} className="form-check mb-2 d-flex align-items-center">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`color-${color.color_id}`}
                                      checked={(ProductUser.available_color || []).includes(String(color.color_id))}
                                      onChange={() => handleColorCheckbox(color.color_id)}
                                    />
                                    <label className="form-check-label d-flex align-items-center" htmlFor={`color-${color.color_id}`}>
                                      <span
                                        className="d-inline-block me-2 ms-2"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          backgroundColor: color.code,
                                          border: "1px solid #ddd",
                                          borderRadius: "3px"
                                        }}
                                      ></span>
                                      {color.color_name}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No colors available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* ELECTRONICS BLOCK */}
                    {String(ProductUser.main_category) === "1" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Electronics Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            name="company_name"
                            value={ProductUser.company_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Apple"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Model Name</label>
                          <input
                            type="text"
                            name="model_name"
                            value={ProductUser.model_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. iPhone 16"
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label">Specifications</label>
                          <div className="row g-3">
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="ram"
                                value={ProductUser.ram}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="RAM (e.g. 8GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="rom"
                                value={ProductUser.rom}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="ROM (e.g. 128GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="processor"
                                value={ProductUser.processor}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Processor"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="camera"
                                value={ProductUser.camera}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Camera"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="battery"
                                value={ProductUser.battery}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Battery (mAh)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="operating_system"
                                value={ProductUser.operating_system}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Operating System"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* FASHION BLOCK */}
                    {String(ProductUser.main_category) === "2" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Fashion Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Brand Name</label>
                          <input
                            type="text"
                            name="fashion_brand_name"
                            value={ProductUser.fashion_brand_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="Enter brand name (e.g. Levi's)"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Material</label>
                          <input
                            type="text"
                            name="material"
                            value={ProductUser.material}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Cotton"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Fit Type</label>
                          <input
                            type="text"
                            name="fit_type"
                            value={ProductUser.fit_type}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Regular Fit"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Occasion</label>
                          <input
                            type="text"
                            name="occasion"
                            value={ProductUser.occasion}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Casual"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Care Instructions</label>
                          <input
                            type="text"
                            name="care_instructions"
                            value={ProductUser.care_instructions}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Machine wash cold"
                          />
                        </div>
                      </>
                    )}

                    {/* Common remaining fields */}
                    <div className="col-lg-6">
                      <label className="form-label">Stock</label>
                      <input
                        type="text"
                        name="prod_stock"
                        value={ProductUser.prod_stock}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter stock quantity"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Rating</label>
                      <input
                        type="text"
                        name="rating"
                        value={ProductUser.rating}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter rating (e.g. 4.5)"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        name="description"
                        value={ProductUser.description}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Short product description"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Product Details</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Additional details"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Weight</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter weight"
                      />
                    </div>


                    <div className="col-lg-6">
                      <label className="form-label">Dimension</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Dimension"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Assign Vendor</label>
                      <select
                        className="form-control"
                        name="prod_vendor_assign"
                        value={ProductUser.prod_vendor_assign}
                        onChange={handleInput}
                      >
                        <option value="">Select Vendor</option>
                        <option value="H&M">H&M</option>
                        <option value="Nike">Nike</option>
                        <option value="Zara">Zara</option>
                      </select>
                    </div>

                    {/* <div className="col-lg-6">
  <label className="form-label">Product Status</label>
  <select
    className="form-control"
    name="product_status"
    value={ProductUser.product_status}
    onChange={handleInput}
  >
    <option value="">-- Select Product Status --</option>
    <option value="Top Deals">Top Deals</option>
    <option value="Fashion Top Deals">Fashion Top Deals</option>
    <option value="Shop Your Favorites">Shop Your Favorites</option>
    <option value="Special Offers">Special Offers</option>
    <option value="Grand Global Brand">Grand Global Brand</option>
    <option value="Shop By Category">Shop By Category</option>
    <option value="Top Pick of the sale">Top Pick of the sale</option>
    <option value="Crazy Deals">Crazy Deals</option>
    <option value="Products for you">Products for you</option>
    <option value="Groceries">Groceries</option>
  </select>
</div> */}

<div className="col-lg-6">
                      <label className="form-label">Paid Promotion</label>
                      <select
                        className="form-control"
                        name="paid_promo"
                        value={ProductUser.paid_promo}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Paid Promotion --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>



                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={ProductUser.status}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Status --</option>
  <option value="In Stock">In Stock</option>
  <option value="Out of Stock">Out of Stock</option>
  <option value="Few Left">Few Left</option>
                      </select>
                    </div>

                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-outline-secondary w-100">
                      Update Product
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/sellerproduct" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid text-center py-3">
          © Venton. Crafted by{" "}
          <span className="text-danger">❤️</span> <strong>Techzaa</strong>
        </div>
      </footer>
    </div>
  );
};

export const SellerProductView = () => {
  const { id } = useParams(); // get product_id from URL
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = async () => {
    try {
      const formData = new FormData();
      formData.append("product_id", id);

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
        formData
      );

      if (res.data.status === true) {
        setProduct(res.data.data);
      } else {
        toast.error("Unable to fetch product details");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error fetching product details");
    }
  };

  if (!product) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center py-5">
          <h4>Loading Product...</h4>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* PAGE HEADER */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Product Details</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><Link to="/sellerproduct">Products</Link></li>
                <li className="breadcrumb-item active">{product.product_name}</li>
              </ol>
            </div>
          </div>
        </div>

        {/* PRODUCT CARD */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">

                  {/* IMAGE BLOCK */}
                  <div className="col-md-4 text-center">
                    <img
                      src={
                        product.multi_image && product.multi_image.length > 0
                          ? `https://cyberathon.com/multivendor/${product.multi_image[0]}`
                          : "https://via.placeholder.com/400x300?text=No+Image"
                      }
                      alt={product.product_name}
                      className="img-fluid rounded shadow"
                    />
                  </div>

                  {/* DETAILS BLOCK */}
                  <div className="col-md-8">
                    <h3 className="fw-bold">{product.product_name}</h3>
                    <p className="text-muted">{product.description}</p>

                    <h4 className="text-primary">₹{product.current_price}</h4>
                    <p className="text-muted text-decoration-line-through">
                      {product.old_price ? `₹${product.old_price}` : ""}
                    </p>

                    <p><strong>Company:</strong> {product.company_name || "N/A"}</p>
                    <p><strong>Model:</strong> {product.model_name || "N/A"}</p>

                    {/* PRODUCT SPECS */}
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <p><strong>RAM:</strong> {product.ram || "N/A"}</p>
                        <p><strong>ROM:</strong> {product.rom || "N/A"}</p>
                        <p><strong>Processor:</strong> {product.processor || "N/A"}</p>
                        <p><strong>Camera:</strong> {product.camera || "N/A"}</p>
                        <p><strong>Battery:</strong> {product.battery || "N/A"}</p>
                      </div>

                      <div className="col-md-6">
                        <p><strong>OS:</strong> {product.operating_system || "N/A"}</p>
                        <p><strong>Available Size:</strong> {product.available_size || "N/A"}</p>
                        <p><strong>Available Color:</strong> {product.available_color || "N/A"}</p>
                        <p><strong>Stock:</strong> {product.stock}</p>
                        <p><strong>Rating:</strong> ⭐ {product.rating}</p>
                      </div>
                    </div>

                    <p className="mt-3"><strong>Vendor:</strong> {product.assign_vendor}</p>

                    {/* STATUS */}
                    <p>
                      <strong>Status:</strong>{" "}
                      <span className={`badge 
                        ${product.status === "Instock" ? "bg-success-subtle text-success"
                          : product.status === "fewleft" ? "bg-warning-subtle text-warning"
                          : "bg-danger-subtle text-danger"} py-1 px-2`}>
                        {product.status}
                      </span>
                    </p>

                    <p><strong>Created:</strong> {product.created_at}</p>

                  </div>
                </div>
              </div>

              {/* BACK BUTTON */}
              <div className="card-footer text-end">
                <Link to="/sellerproduct" className="btn btn-primary">
                  Back to Product List
                </Link>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
